import React from 'react';

interface AvatarProps {
  imageUrl?: string;
  name?: string;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ imageUrl, name, className = '' }) => {
  return (
    <div className={`h-14 w-14 overflow-hidden rounded-full border border-slate-300 ${className}`}>
      {imageUrl ? (
        <img src={imageUrl} alt={name || 'Avatar'} className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-gray-200">
          {name && <span className="text-sm font-semibold text-gray-600">{name.charAt(0).toUpperCase()}</span>}
        </div>
      )}
    </div>
  );
};
